import { Button } from 'antd';
import styled from 'styled-components';
import { Icon } from 'components/common';
import { colours } from 'utils/theme';
import * as strings from './strings';

// Org-profile stage-one banner: sits under the (still editable) query and offers to
// re-run it on main search in a new tab. Two ways in, and they need different wording
// — the query is about something else, or it is fine but needs filters only main
// search carries.

const Banner = styled.div`
  display: flex;
  gap: 8px;
  border-radius: 2px;
  padding: 9px 16px;
  border: 1px solid #91d5ff;
  background: #e6f7ff;
  margin-top: 12px;
  font-size: 12px;
`;

// One message line tall, so the icon centres on the first line however the text wraps.
const IconSlot = styled.div`
  display: flex;
  align-items: center;
  height: 20px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
`;

const Message = styled.p`
  line-height: 20px;
  color: ${colours.character.primary85};
  margin: 0;
`;

/**
 * @param {Object} props
 * @param {string} props.organisationName
 * @param {'irrelevant' | 'unsupported-filters'} [props.reason]
 * @param {() => void} props.onRunOnMainSearch
 */
export function NLPOrgRedirectView({
  organisationName,
  reason = 'irrelevant',
  onRunOnMainSearch,
}) {
  const { lead, action } =
    reason === 'unsupported-filters'
      ? strings.orgUnsupportedFiltersRedirect(organisationName)
      : strings.orgIrrelevantRedirect(organisationName);

  return (
    <Banner data-testid='nlp-org-main-search-redirect' role='status'>
      <IconSlot>
        <Icon icon='circleInfo' size='sm' color={colours.blue} />
      </IconSlot>
      <Body>
        <Message>
          {lead}
          <br />
          {action}
        </Message>
        <Button
          type='primary'
          size='small'
          data-testid='nlp-org-run-on-main-search'
          onClick={onRunOnMainSearch}
        >
          Run on main search
        </Button>
      </Body>
    </Banner>
  );
}
